import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../config";
import { setError } from "./errorSlice";
export const fetchSchools = createAsyncThunk(
  "school/fetchSchools",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(`${API_BASE_URL}/api/School`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
      }

      const data = await response.json();
      console.log("2-----schools", data);
      return data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const createSchool = createAsyncThunk(
  "school/createSchool",
  async (schoolData, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      // Only send schoolName and state
      const payload = {
        schoolName: schoolData.schoolName,
        state: Boolean(schoolData.state),
      };

      //      console.log("Creating school with payload:", payload);

      const response = await fetch(`${API_BASE_URL}/api/School/Create`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Server error response:", errorText);
        throw new Error(errorText || "Failed to create school");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Create school error:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const updateSchool = createAsyncThunk(
  "school/updateSchool",
  async ({ id, schoolName }, { rejectWithValue, dispatch }) => {
    try {
      console.log("id, schoolName", id, schoolName);
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const payload = {
        schoolId: id,
        schoolName: schoolName,
      };

      //      console.log("Updating school with payload:", payload);

      const response = await fetch(`${API_BASE_URL}/api/School/Update`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      console.log("response ", response);

      const responseText = await response.text();

      if (!response.ok) {
        throw new Error(responseText || "Failed to update school");
      }

      try {
        console.log("Raw response:", responseText);
        const data = JSON.parse(responseText);
        console.log("Raw data:", data);
        return {
          schoolId: id, // Make sure this matches your school objects
          schoolName: schoolName,
        };
        //   return data;
      } catch (parseError) {
        console.error("JSON parse error:", parseError);
        throw new Error("Invalid response format from server");
      }
    } catch (error) {
      console.error("Update school error:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSchool = createAsyncThunk(
  "school/deleteSchool",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(`${API_BASE_URL}/api/School/delete/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Server error response:", errorText);
        throw new Error(errorText || "Failed to delete school");
      }
      return id;
    } catch (error) {
      console.error("Delete school error:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  schools: [],
  loading: false,
  error: null,
  editingSchool: null,
  modalVisible: false,
};

const divisionSlice = createSlice({
  name: "schools",
  initialState,
  reducers: {
    setEditingSchool: (state, action) => {
      state.editingSchool = action.payload;
      state.modalVisible = !!action.payload;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch schools
      .addCase(fetchSchools.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSchools.fulfilled, (state, action) => {
        state.loading = false;
        console.log("state.schools", action.payload);
        state.schools = action.payload;
      })
      .addCase(fetchSchools.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create school
      .addCase(createSchool.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSchool.fulfilled, (state, action) => {
        state.loading = false;
        state.schools.push(action.payload);
        state.editingSchool = null;
        state.modalVisible = false;
      })
      .addCase(createSchool.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update school
      .addCase(updateSchool.pending, (state) => {
        console.log("school pending, ");
        state.loading = true;
        state.error = null;
      })
      // In your extraReducers builder:
      .addCase(updateSchool.fulfilled, (state, action) => {
        state.loading = false;

        // Update specific school in array
        const index = state.schools.findIndex(
          (school) => school.schoolId === action.payload.schoolId
        );

        if (index !== -1) {
          state.schools[index] = {
            ...state.schools[index],
            schoolName: action.payload.schoolName,
          };
        }

        // Reset editing state
        state.editingSchool = null;
        state.modalVisible = false;
      })
      .addCase(updateSchool.rejected, (state, action) => {
        console.log("school rejected, ");

        state.loading = false;
        state.error = action.payload;
      })
      // Delete school
      .addCase(deleteSchool.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSchool.fulfilled, (state, action) => {
        state.loading = false;
        state.schools = state.schools.filter(
          (school) => school.schoolId !== action.payload
        );
      })
      .addCase(deleteSchool.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setEditingSchool } = divisionSlice.actions;
export default divisionSlice.reducer;
